import { endpoints, oids } from "../../../configs/Settings";
import { useAxios } from "../../../utils/useAxios";
import { HTTPResponseStatus } from "../../../utils/enum";

import { useAuth } from "../../../utils/useAuth";
import { toast } from "react-toastify";
import { OAuthApplication } from "../../auth";
import { getAuthToken } from "@/services/auth/OAuthApplication";

interface IProps {
  identifier?: string;
  name?: string;
  gender?: string;
  birthDate?: string;
  authType?: string;
  vetPatient?: boolean; // Se true, adiciona header X-Target-System: vet
}

export async function GetPatient({
  identifier,
  name,
  gender,
  birthDate,
  authType,
  vetPatient,
}: IProps) {
  let url = `${endpoints.MPIFHIR}/Patient`;
  if (identifier) url = `${url}/${oids.cpf}-${identifier}`;
  if (name) url = `${url}?name=${name}`;
  if (gender) url = `${url}&gender=${gender}`;
  if (birthDate) url = `${url}&birthdate=${birthDate}`;

  // Headers base
  const headers: any = {
    Authorization: await getAuthToken(),
    "Content-Type": "application/fhir+json",
    Accept: "application/fhir+json",
  };

  // Adiciona header X-Target-System: vet se vetPatient for true
  if (vetPatient) {
    headers["X-Target-System"] = "vet";
  }
  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`DeletePatient: ${response.status}`);
      }
      return { status: HTTPResponseStatus.Success, data: response.data };
    })
    .catch((error) => {
      console.error("GetPatient ", error);
      // toast.error(`GetPatient Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
